import accessCodeForm from './accessCodeForm';
import authErrorModal from './authErrorModal';
import conversationExpired from './conversationExpired';
import generalError from './ErrorBoundaries/generalError';
import message from './message';
import messageInput from './compose';
import messageStatus from './messageStatus';
import requestAccessPage from './requestAccessPage';
import sendButton from './compose';
import virtualWaitingRoom from './virtualWaitingRoom';

// react-intl requires flattened objects so anything imported must be expanded
export default {
  ...accessCodeForm,
  ...authErrorModal,
  ...conversationExpired,
  ...generalError,
  ...message,
  ...messageInput,
  ...messageStatus,
  ...requestAccessPage,
  ...sendButton,
  ...virtualWaitingRoom,
  loading: 'Loading...',
};
